<div class="d-flex align-items-center gap-2">
<button *ngIf="showBackButton" class="sort-btn back-btn" (click)="backClick.emit()">
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
  {{ 'shared-components.back-button' | translate }}
</button>
<div
  class="position-relative"
  #dropdownContainer
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <button
    class="dropdown-container cursor-pointer"
    (click)="openDropdown($event)"
  >
    <div class="sort-section">
      <button
        class="sort-btn"
        [class.sort-btn--has-selection]="!!selectedValue"
      >
        <svg class="sort-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <line x1="4" y1="6" x2="20" y2="6"></line>
          <line x1="4" y1="12" x2="15" y2="12"></line>
          <line x1="4" y1="18" x2="10" y2="18"></line>
        </svg>
        {{ label || ("shared-components.selector.sort" | translate) }}
      </button>
    </div>
  </button>
  <div
    class="dropdown-menu"
    *ngIf="isDropdownOpen$ | async"
    (click)="closeDropdown($event)"
  >
    <div
      *ngFor="let option of data"
      (click)="selectOption(option)"
      class="dropdown-option"
      [class.dropdown-option--selected]="option === selectedValue"
    >
      {{ "shared-components.selector." + option | translate }}
    </div>
  </div>
</div>
</div>
